import {
  removeAlphabeticCharacteres,
  stringNullOrEmpty,
} from 'utilities/string.util'

export const formatPhoneNumber = (strPhoneNumber?: string): string => {
  if (!strPhoneNumber) return ''

  if (stringNullOrEmpty(strPhoneNumber)) strPhoneNumber = ''

  let formattedValue = removeAlphabeticCharacteres(strPhoneNumber)

  // Limit to 11 digits (standard BR phone: 2-digit area + 9-digit number)
  formattedValue = formattedValue.slice(0, 11)

  const areaCode = formattedValue.slice(0, 2)
  const part1 = formattedValue.slice(2, 7)
  const part2 = formattedValue.slice(7, 11)

  if (formattedValue.length > 7) {
    return `(${areaCode}) ${part1}-${part2}`
  } else if (formattedValue.length > 2) {
    return `(${areaCode}) ${part1}`
  } else if (formattedValue.length > 0) {
    return `(${areaCode}`
  }

  return ''
}
